import { getLocaleForLanguage, getStoredLanguage } from '../contexts/I18nContext'

const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/
const MONTH_ABBREVIATIONS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function parseDateOnlyAsLocal(value: string): Date {
	const [year, month, day] = value.split('-').map(Number)
	return new Date(year, month - 1, day)
}

function resolveDate(date: string | Date): Date {
	if (typeof date === 'string' && DATE_ONLY.test(date)) {
		return parseDateOnlyAsLocal(date)
	}

	return typeof date === 'string' ? new Date(date) : date
}

export function formatDate(date: string | Date, locale = 'en-US'): string {
	void locale
	const resolved = resolveDate(date)
	if (Number.isNaN(resolved.getTime())) {
		return ''
	}

	const day = resolved.getDate()
	const month = MONTH_ABBREVIATIONS[resolved.getMonth()]
	const year = String(resolved.getFullYear()).slice(-2)

	return `${day}-${month}-${year}`
}

export function formatMonthYear(date: string | Date, locale = 'en-US'): string {
	const resolved = resolveDate(date)
	return new Intl.DateTimeFormat(locale === 'en-US' ? getLocaleForLanguage(getStoredLanguage()) : locale, { month: 'long', year: 'numeric' }).format(resolved)
}

export function toDateInputValue(date: string | Date): string {
	if (typeof date === 'string' && DATE_ONLY.test(date)) {
		return date
	}
	const resolved = resolveDate(date)
	return [
		String(resolved.getFullYear()),
		String(resolved.getMonth() + 1).padStart(2, '0'),
		String(resolved.getDate()).padStart(2, '0'),
	].join('-')
}

export function daysUntil(date: string | Date): number {
	const resolved = resolveDate(date)
	const today = new Date()
	const start = new Date(today.getFullYear(), today.getMonth(), today.getDate())
	const end = new Date(resolved.getFullYear(), resolved.getMonth(), resolved.getDate())
	return Math.round((end.getTime() - start.getTime()) / 86_400_000)
}

export function startOfMonth(year: number, month: number): string {
	return new Date(Date.UTC(year, month - 1, 1)).toISOString().slice(0, 10)
}

export function endOfMonth(year: number, month: number): string {
	return new Date(Date.UTC(year, month, 0)).toISOString().slice(0, 10)
}